import type { ComponentType, ReactNode } from 'react';

import classNames from 'classnames';

import { Attention } from '../../icons/mono/Attention';

export enum HintVariant {
  DANGER = 'DANGER',
  INFO = 'INFO',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  DISABLED = 'DISABLED',
}

type ColorConfig = {
  bg: string;
  icon: string;
};

const ColorsMap: Record<HintVariant, ColorConfig> = {
  [HintVariant.DANGER]: {
    bg: 'bg-base-bg-secondary-orange',
    icon: 'text-base-text-orange',
  },
  [HintVariant.INFO]: {
    bg: 'bg-base-bg-secondary-blue',
    icon: 'text-base-text-blue',
  },
  [HintVariant.ERROR]: {
    bg: 'bg-base-bg-secondary-red',
    icon: 'text-base-text-red',
  },
  [HintVariant.SUCCESS]: {
    bg: 'bg-base-bg-secondary-green',
    icon: 'text-base-text-green',
  },
  [HintVariant.DISABLED]: {
    bg: 'bg-base-bg-secondary',
    icon: 'text-base-text-quaternary',
  },
};

type Props = {
  message: ReactNode;
  description?: string;
  variant?: HintVariant;
  fullWidth?: boolean;
  Icon?: ComponentType<{ className?: string }>;
  bold?: boolean;
};

export const Hint = ({
                       message,
                       description = '',
                       variant = HintVariant.INFO,
                       fullWidth = true,
                       Icon = Attention,
                       bold = false,
                     }: Props) => {
  const color = ColorsMap[variant];
  const CurrentIcon = Icon;

  return (
    <span
      className={classNames(
        `flex pt-2 px-4 max-sm-msq:pb-2 rounded-xl gap-2 ${color.bg}`,
        description ? 'pb-3' : 'pb-2',
        fullWidth ? 'w-full' : 'w-fit',
      )}
    >
      <CurrentIcon className={`mt-1 msq-icon msq-icon-xs ${color.icon}`} />
      <div className="flex flex-col">
        <div
          className={classNames(
            'text-base-text-primary',
            description ? 'text-body-sm-strong-a' : 'text-body-sm-a',
            bold && 'font-bold',
          )}
        >
          {message}
        </div>
        {description && (
          <div className="text-base-text-secondary text-body-xs-a">{description}</div>
        )}
      </div>
    </span>
  );
};
